const ContractAddr = "0x8600B1B549d9F9A5cDB0a100cB448b87efEF3C1C";

export default ContractAddr;
